import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const COUNTRY = "55";

export const toLocalDigits = (value) => {
  const s = String(value || "").trim();
  let d = s.replace(/\D/g, "");
  if (s.includes("+")) {
    if (d.startsWith(COUNTRY)) d = d.slice(COUNTRY.length);
  } else if (d.startsWith(COUNTRY) && d.length > 11) {
    d = d.slice(COUNTRY.length);
  }
  return d.slice(0, 11);
};

export const toE164 = (value) => {
  const d = toLocalDigits(value);
  return d ? `+${COUNTRY}${d}` : "";
};

export const formatBRPhone = (value) => {
  const d = toLocalDigits(value);
  if (!d) return "";
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  if (rest.length <= 4) return `(${ddd}) ${rest}`;
  const split = rest.length > 8 ? 5 : 4;
  return `(${ddd}) ${rest.slice(0, split)}-${rest.slice(split)}`;
};

export function PhoneInput({ value, onChange, className, inputClassName, placeholder = "(61) 99183-0791", ...props }) {
  const digits = toLocalDigits(value);
  const formatted = formatBRPhone(digits);

  const handleChange = (e) => {
    const raw = e.target.value;
    let next = raw.replace(/\D/g, "").slice(0, 11);
    if (raw.length < formatted.length && next === digits) next = next.slice(0, -1);
    onChange(next ? `+${COUNTRY}${next}` : "");
  };

  return (
    <div className={cn("flex items-stretch", className)}>
      <span
        className="flex items-center px-3 rounded-l-md border border-r-0 border-stone-200 bg-stone-100 text-stone-500 text-sm font-mono select-none"
        data-testid={props["data-testid"] ? `${props["data-testid"]}-prefix` : undefined}
      >
        +{COUNTRY}
      </span>
      <Input
        {...props}
        type="tel"
        inputMode="numeric"
        value={formatted}
        onChange={handleChange}
        placeholder={placeholder}
        className={cn("rounded-l-none bg-white", inputClassName)}
      />
    </div>
  );
}
